import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import Thread from '../../components/thread/Thread';
import { fetchData, validateUsersContract } from "../../services/stacks";
import { stacksApi, deruptFeedContractAddress, clientNetwork } from '../../lib/constants';
import './style.scss';
import LoadNewChimesChip from '../../components/chip/Chip';
import { FaUsers, FaUsersBetweenLines } from "react-icons/fa6";
import { TbWorld, TbWorldStar } from "react-icons/tb";
import { cvToJSON, hexToCV } from '@stacks/transactions';
import LoadMoreOriginChimes from '../../components/findoriginchimes/index';
import MediaPlayer from '../../components/snackmediaplayer/index';
import { isUserSignedIn } from '../../services/auth';
import UserContractDeployModal from '../../components/modal/UserContractDeployModal';
import WoopsModal from '../../components/modal/WoopsModal';
import ConfirmModal from '../../components/modal/ConfirmModal';
import AdvisoryModal from '../../components/modal/AdvisoryModal';

const appOrigin = window.location.origin;

const HomePage = ({ setReplyOpen, userSettings }) => {
  const [tempStorageUrlCache, setTempStorageUrlCache] = useState([]);
  const [offset, setOffset] = useState(0);
  const [chimeResults, setChimeResults] = useState([]);
  const [followingList, setFollowingList] = useState([]);
  const [mutedList, setMutedList] = useState([]);
  const [loading, setLoading] = useState(true);

  const [followedChimes, setFollowedChimes] = useState(false);
  const [originChimes, setOriginChimes] = useState(false);
  const [playList, setPlayList] = useState([]);
  const [openMediaPlayer, setOpenMediaPlayer] = useState(false);

  const [selectedChimeTx, setSelectedChimeTx] = useState(0);
  const [mediaCurrentTime, setMediaCurrentTime] = useState({ currentTime: 0, playorPaused: false, txId: '' });

  // Modal states
  const [userContractStatus, setUserContractStatus] = useState('');
  const [showUserContractDeployModal, setShowUserContractDeployModal] = useState(false);
  const [showWoopsModal, setShowWoopsModal] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [showAdvisoryModal, setShowAdvisoryModal] = useState(false);

  const [txId, setTxId] = useState('');
  const [tx_Id, setTx_Id] = useState('');

  const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

  //Validate that the user contract is deployed so they can actually call their contract when trying to do actions.
  async function validating(open, value) {
    const { state, txId } = await validateUsersContract();
    setTxId(txId);
    setUserContractStatus(state);
    switch (state) {
      case true:
        open(value);
        break;
      case false:
      case 'success':
      case 'mempool':
      case 'abort_by_post_condition':
      case 'abort_by_response':
        setShowUserContractDeployModal(true);
        break;
      case 'updateNeeded':
        setShowAdvisoryModal(true);
        break;
      default:
        if (isUserSignedIn()) {
          setShowUserContractDeployModal(true);
        } else {
          setShowWoopsModal(true);
        }
        break;
    }
  }

  const handleFollowChimesToggle = () => {
    if (followedChimes) {
      setFollowingList([]);
      setFollowedChimes(!followedChimes);
    } else {
      fetchData('followinglist.json')
        .then(({ result }) => {
          setFollowingList(result && result);
          setFollowedChimes(!followedChimes);
        });
    }
  };

  const handleOriginhimesToggle = () => {
    setOriginChimes(!originChimes);
  };

  async function loadChimes() {
    try {
      setLoading(true);
      await delay(2500);
      const { results } = (await axios.get(`${userSettings?.stacksApi || stacksApi[clientNetwork]}/extended/v1/contract/${deruptFeedContractAddress}/events?limit=5&offset=${offset}`)).data;
      if (results.length === 0) {
        setLoading(false);
        return;
      }
      const filteredResults = results.filter((content) => {
        const { tx_id, contract_log: { value: { hex } } } = content;
        const { publisher } = cvToJSON(hexToCV(hex)).value;
        if (mutedList[tx_id]) return false;
        if (mutedList[publisher.value]) return false;
        return content;
      });

      setChimeResults(chimeResults => [...chimeResults, ...filteredResults]);
      setOffset(offset + 5);
    } catch (error) {
      console.error('Error fetching chime results:', error);
    } finally {
      setLoading(false);
    }
  }

  // Onscroll handler
  useEffect(() => {
    let timer;
    const handleScrollWithTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const { scrollTop, clientHeight, scrollHeight } = document.documentElement || document.body;
        if (((scrollTop + clientHeight) >= (scrollHeight - 2500)) && !loading) {
          loadChimes();
        }
      }, 500);
    };
    window.addEventListener('scroll', handleScrollWithTimer);
    return () => {
      window.removeEventListener('scroll', handleScrollWithTimer);
      clearTimeout(timer);
    };
  }, [offset, loading]);

  const init = async () => {
    try {
      const { result, success } = await fetchData('mutedlist.json');
      if (success) setMutedList(result);
    } catch (error) {
      console.log('mutedlist error!', error);
    }
    try {
      const { result, success } = await fetchData('followinglist.json');
      if (success) {
        setFollowingList(result);
      }
    } catch (error) {
      console.log('followlist error!', error);
    }
    await validating(setLoading, false);
    loadChimes();
  };

  useMemo(() => {
    init();
  }, []);

  return (
    <>
      <div className='home-page'>
        {chimeResults.length > 0 && <LoadNewChimesChip setChimeResults={setChimeResults} chimeResults={chimeResults} />}
        {/* <div className='home-filter-switch'>
          {originChimes ? <TbWorldStar onClick={handleOriginhimesToggle} size={25} color='#f7931a' style={{ margin: '.5rem 1.5rem', cursor: 'pointer' }} /> : <TbWorld onClick={handleOriginhimesToggle} color='#6444fe' style={{ margin: '.5rem 1.5rem', cursor: 'pointer' }} size={25} />}
          {followedChimes ? <FaUsersBetweenLines onClick={handleFollowChimesToggle} size={25} color='#f7931a' style={{ margin: '.5rem 0rem', cursor: 'pointer' }} /> : <FaUsers onClick={handleFollowChimesToggle} color='#6444fe' style={{ margin: '.5rem 0rem', cursor: 'pointer' }} size={25} />}
        </div> */}
        {chimeResults
          .filter((content) => {
            const { tx_id, contract_log: { topic, value: { hex } } } = content;
            const { "alt-origin": altOrigin, publisher } = cvToJSON(hexToCV(hex)).value;
            if (mutedList[tx_id]) return false;
            if (mutedList[publisher.value]) return false;
            if (originChimes === true && altOrigin?.value !== appOrigin) return false;
            if (followedChimes === true) return followingList[publisher.value];
            if (topic !== 'print') return false;
            return content;
          })
          .map(({ tx_id, contract_log: { value: { hex } } }, index) => {
            return (
              <div className='home-thread-container' key={index}>
                <Thread key={tx_id} baseTxId={tx_id} mutedList={mutedList} hex={hex} setReplyOpen={setReplyOpen} threading={true}
                  tempStorageUrlCache={tempStorageUrlCache} setTempStorageUrlCache={setTempStorageUrlCache}
                  playList={playList} setPlayList={setPlayList} mediaCurrentTime={mediaCurrentTime} setMediaCurrentTime={setMediaCurrentTime}
                  openMediaPlayer={openMediaPlayer} setOpenMediaPlayer={setOpenMediaPlayer}
                  userSettings={userSettings}
                  index={index} selectedChimeTx={selectedChimeTx} setSelectedChimeTx={setSelectedChimeTx}

                  setShowUserContractDeployModal={setShowUserContractDeployModal}
                  setShowWoopsModal={setShowWoopsModal}
                  setOpenConfirmModal={setOpenConfirmModal}
                  userContractStatus={userContractStatus}

                  txId={txId}
                  setTxId={setTxId}
                  tx_Id={tx_Id}
                  setTx_Id={setTx_Id}
                />
              </div>
            )
          })
        }
        {chimeResults.length > 0 && <LoadMoreOriginChimes chimeResults={chimeResults} originChimes={originChimes} loadChimes={loadChimes} />}
        {loading === true ? <div>Loading...</div> : null}
      </div>

      {/*  */}
      {(openMediaPlayer && playList.length > 0) ? <MediaPlayer openMediaPlayer={openMediaPlayer} setOpenMediaPlayer={setOpenMediaPlayer} playList={playList} setPlayList={setPlayList} selectedChimeTx={selectedChimeTx} setMediaCurrentTime={setMediaCurrentTime} setSelectedChimeTx={setSelectedChimeTx} setReplyOpen={setReplyOpen}
        setShowUserContractDeployModal={setShowUserContractDeployModal}
        setShowWoopsModal={setShowWoopsModal}
        setOpenConfirmModal={setOpenConfirmModal}
        userContractStatus={userContractStatus}

        txId={txId}
        setTxId={setTxId}
        tx_Id={tx_Id}
        setTx_Id={setTx_Id}
      /> : null}
      {showUserContractDeployModal && (<UserContractDeployModal show={showUserContractDeployModal} setShow={setShowUserContractDeployModal} txId={txId} setTxId={setTxId} openConfirmModal={setOpenConfirmModal} setTx_Id={setTx_Id} userContractStatus={userContractStatus} setUserContractStatus={setUserContractStatus} userSettings={userSettings} />)}
      {showWoopsModal && (<WoopsModal show={showWoopsModal} setShow={setShowWoopsModal} close={() => setShowWoopsModal(false)} />)}
      {openConfirmModal && (<ConfirmModal show={openConfirmModal} setShow={setOpenConfirmModal} txId={tx_Id} close={() => setOpenConfirmModal(false)} userSettings={userSettings} />)}
      {showAdvisoryModal && (<AdvisoryModal show={showAdvisoryModal} close={() => setShowAdvisoryModal(false)} />)}
    </>

  );
};

export default HomePage;
